import React, { Component } from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import styled from "styled-components";
import { Link } from "react-router-dom";
import ScroollTableKoga3arz from "./ScroollTableKoga3arz";
import NumberFormat from "react-number-format";
import { multiply } from "lodash";
class ModelKoga3arz extends Component {
  render() {
    return (
      <ProductConsumer>
        {(value) => {
          const {
            HK_modalOpen,
            HK_CloseModal,
            getPrint,
            AddProChange,
            HK_code2,
            aynamictoanotherInput,
            HK_getProductDetail,
            HK_all3arzKala,
            HK_draw,
            HK_delete
          } = value;
          let arr = [];
          for (let i = HK_all3arzKala.length; i > 0; i--) {
            const el = HK_all3arzKala[i - 1];
            if (el) {
              arr = [...arr, el];
            }
          }
          if (!HK_modalOpen) {
            return null;
          } else {
            return (
              <ModalContainer>
                <div className="container">
                  <div className="row">
                    <div
                      id="modal"
                      className="col-10 mx-auto col-10 col-lg-10 text-center text-capitalize p-5"
                    >
                      <br />
                      <form>
                        <div className="row mb-4">
                          <div className="col-2">
                            <button
                              className="btn btn-danger"
                              onClick={() => HK_CloseModal()}
                            >
                              X
                            </button>
                          </div>
                          <div className="col-1">
                            <Link
                              to="/print-3arz"
                              onClick={(e) => {
                                getPrint(e);
                                HK_CloseModal(e);
                              }}
                            >
                              <button className="btn btn-warning ml-4">
                                چاپ
                              </button>
                            </Link>
                          </div>
                          <div className="col-3 ml4">
                            <select
                              className={`form-control text-right font-weight-bold selectpicker pull-right ${
                                HK_draw == "دۆلار"
                                  ? "bg-success text-white"
                                  : `${
                                      HK_draw == "دینار"
                                        ? "bg-danger text-white"
                                        : ""
                                    }`
                              }`}
                              onChange={AddProChange}
                              name="HK_draw"
                              value={HK_draw != null ? HK_draw : ""}
                            >
                              <option className="ml5">جۆری دراو</option>
                              <option>دۆلار</option>
                              <option>دینار</option>
                            </select>
                          </div>
                          <div className="col-3">
                            <input
                              type="text"
                              name="HK_code2"
                              value={HK_code2}
                              onChange={AddProChange}
                              aria-label="Large"
                              className="form-control"
                              placeholder="کۆد"
                              onKeyPress={(event) =>
                                event.key == "Enter"
                                  ? aynamictoanotherInput(
                                      event,
                                      0,
                                      "p",
                                      HK_getProductDetail
                                    )
                                  : null
                              }
                            />
                          </div>
                          <div className="col-3"></div>
                        </div>
                      </form>
                      <div style={{ height: "350px" }}>
                        <div className="JMHK">
                          <table
                            id="example"
                            className="table table-hover table-bordered text-right "
                          >
                            <thead>
                              <tr
                                className="text-warning f4"
                                style={{ backgroundColor: "#2C3539" }}
                              >
                                <th style={{ border: "2px solid #f0ad4e" }}>
                                  نرخ کارتۆن
                                </th>
                                {HK_draw == "دۆلار" ? (
                                  <>
                                    <th style={{ border: "2px solid #f0ad4e" }}>
                                      نرخ دەرزەن
                                    </th>
                                  </>
                                ) : HK_draw == "دینار" ? (
                                  <>
                                    <th style={{ border: "2px solid #f0ad4e" }}>
                                      کەمتر لە 10
                                    </th>
                                    <th style={{ border: "2px solid #f0ad4e" }}>
                                      کەمتر لە نیو
                                    </th>
                                    <th style={{ border: "2px solid #f0ad4e" }}>
                                      نرخ دەرزەن
                                    </th>
                                  </>
                                ) : null}
                                <th style={{ border: "2px solid #f0ad4e" }}>
                                  عدد
                                </th>
                                <th style={{ border: "2px solid #f0ad4e" }}>
                                  دەرزەن
                                </th>
                                <th style={{ border: "2px solid #f0ad4e" }}>
                                  کارتۆن
                                </th>
                                <th style={{ border: "2px solid #f0ad4e" }}>
                                  ناوەی کاڵا
                                </th>
                                <th style={{ border: "2px solid #f0ad4e" }}>
                                  کۆد
                                </th>
                                <th style={{ border: "2px solid #f0ad4e" }}>
                                  x
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {arr.map((user, i) => {
                                return (
                                  <>
                                    {HK_draw == "دۆلار" ||
                                    HK_draw == "دینار" ? (
                                      <tr key={i} className="f4">
                                        <td
                                          className="fk"
                                          style={{
                                            border: "2px solid #f0ad4e"
                                          }}
                                        >
                                          {HK_draw == "دۆلار" ? (
                                            Number(
                                              multiply(
                                                Number(user.numberOfDarzan),
                                                Number(user.saleDolar)
                                              )
                                            ).toFixed(2)
                                          ) : HK_draw == "دینار" ? (
                                            <NumberFormat
                                              value={multiply(
                                                Number(
                                                  user.numberOfDarzan
                                                ).toFixed(2),
                                                Number(user.saleDinar).toFixed(
                                                  2
                                                )
                                              )}
                                              thousandSeparator={true}
                                              displayType="text"
                                            />
                                          ) : null}
                                        </td>

                                        {HK_draw == "دۆلار" ? (
                                          <>
                                            {" "}
                                            <td
                                              className="fk"
                                              style={{
                                                border: "2px solid #f0ad4e"
                                              }}
                                            >
                                              {Number(user.saleDolar).toFixed(
                                                2
                                              )}
                                            </td>
                                          </>
                                        ) : HK_draw == "دینار" ? (
                                          <>
                                            {" "}
                                            <td
                                              className="fk"
                                              style={{
                                                border: "2px solid #f0ad4e"
                                              }}
                                            >
                                              <NumberFormat
                                                value={Number(
                                                  user.saleOfLessTenDarzan
                                                )}
                                                thousandSeparator={true}
                                                displayType="text"
                                              />
                                            </td>
                                            <td
                                              className="fk"
                                              style={{
                                                border: "2px solid #f0ad4e"
                                              }}
                                            >
                                              <NumberFormat
                                                value={Number(
                                                  user.saleOfLessHalfCarton
                                                )}
                                                thousandSeparator={true}
                                                displayType="text"
                                              />
                                            </td>
                                            <td
                                              className="fk"
                                              style={{
                                                border: "2px solid #f0ad4e"
                                              }}
                                            >
                                              <NumberFormat
                                                value={Number(user.saleDinar)}
                                                thousandSeparator={true}
                                                displayType="text"
                                              />
                                            </td>
                                          </>
                                        ) : null}
                                        <td
                                          className="fk"
                                          style={{
                                            border: "2px solid #f0ad4e"
                                          }}
                                        >
                                          {Number(
                                            multiply(user.numberOfDarzan, 12)
                                          ).toFixed(2)}
                                        </td>
                                        <td
                                          className="fk"
                                          style={{
                                            border: "2px solid #f0ad4e"
                                          }}
                                        >
                                          {user.numberOfDarzan}
                                        </td>
                                        <td
                                          className="fk"
                                          style={{
                                            border: "2px solid #f0ad4e"
                                          }}
                                        >
                                          1
                                        </td>
                                        <td
                                          className="fk"
                                          style={{
                                            border: "2px solid #f0ad4e"
                                          }}
                                        >
                                          {user.nameofproduct}
                                        </td>
                                        <td
                                          className="fk"
                                          style={{
                                            border: "2px solid #f0ad4e"
                                          }}
                                        >
                                          {user.code}
                                        </td>
                                        <td
                                          className="fk"
                                          style={{
                                            border: "2px solid #f0ad4e"
                                          }}
                                        >
                                          <span
                                            className="btn btn-sm btn-danger"
                                            onClick={(e) =>
                                              HK_delete(e, user._id)
                                            }
                                          >
                                            X
                                          </span>
                                        </td>
                                      </tr>
                                    ) : null}
                                  </>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalContainer>
            );
          }
        }}
      </ProductConsumer>
    );
  }
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  #modal {
    background: #f3e29f;
  }
`;

export default ModelKoga3arz;
